const projectData = [
    {
        title: "HEXPLORE",
        image: "/hexplore.png",
        description: "A fully responsive modern full stack social media application with all advance social media features such as google authentication, create, edit, delete, and save images, comment on other users post, and filter images.",
        link: "https://hexplore.netlify.app/"
    },
    {
        title: "PORTFOLIO WEBSITE",
        image: "/portfolio.png",
        description: "An application developed using react, CSS and Boostrap",
        link: "https://michael-react-website.netlify.app/"
    },
    {
        title: "POKEDEX",
        image: "/pokedex.png",
        description: "An application developed using react, fetch, and Material UI",
        link: "https://pokedex-newapi.netlify.app/"
    },
    {
        title: "TODO APP",
        image: "/todo.png",
        description: "A todo application developed using react, redux and Boostrap",
        link: "https://todo-appwithredux.netlify.app/"
    },
    {
        title: "OPEN WEATHER APP",
        image: "/weather.png",
        description: "A weather checking website developed using html, css, and Javascript",
        link: "https://michael0814772.github.io/open-weather-app/"
    },
    {
        title: "CALCULATOR",
        image: "/calculat.png",
        description: "A calculator developed using html, css, and Javascript",
        link: "https://michael0814772.github.io/calculator-app/"
    },
    {
        title: "ECOMMERCE APP",
        image: "/ecommerce.png",
        description: "An ecommerce application developed using react,redux and Boostrap",
        link: "https://ecommerce-demo-eae2da.netlify.app/"
    },
    {
        title: "MOMENT CHROME EXTENSION",
        image: "/chrome.png",
        description: "A website developed using html, css, Javascript, and Local storage",
        link: "https://michael0814772.github.io/moment-chrome-extension/"
    }
]

export default projectData;